// toggle articles filter in Blog templates

const filter = document.querySelector("[data-blog-articles-filter]");
if (filter) {
  const filterButton = filter.querySelector("[data-blog-articles-filter-button]");
  if (filterButton) {
    const filterDropdown = filter.querySelector("[data-blog-articles-filter-dropdown]");
    filterButton.addEventListener("click", () => {
      const dropdownStatus = filterDropdown.dataset.blogArticlesFilterDropdown;
      if (dropdownStatus === "close") {
        filterDropdown.dataset.blogArticlesFilterDropdown = "open";
      } else if (dropdownStatus === "open") {
        filterDropdown.dataset.blogArticlesFilterDropdown = "close";
      }
    })
  }
}
